import { render, staticRenderFns } from "./EditPageDetailsURLSettings.vue?vue&type=template&id=4a60e068&"
import script from "./EditPageDetailsURLSettings.vue?vue&type=script&lang=js&"
export * from "./EditPageDetailsURLSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports